import * as React from 'react';

import { type NotificationState, useNotificationState } from '../hooks/useNotificationState';

// Re-export the NotificationState type for convenience
export type { NotificationState };

type NotificationContextType = {
  notification: NotificationState;
  showNotification: (notification: Omit<NotificationState, 'isVisible'>) => void;
  hideNotification: (notificationId?: string) => void;
  isNotificationVisible: (id: string) => boolean;
};

const NotificationContext = React.createContext<NotificationContextType | null>(null);

type NotificationProviderProps = {
  children: React.ReactNode;
};

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const notificationState = useNotificationState();

  return <NotificationContext.Provider value={notificationState}>{children}</NotificationContext.Provider>;
};

export const useNotificationContext = (): NotificationContextType => {
  const context = React.useContext(NotificationContext);

  if (!context) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }

  return context;
};

export default NotificationContext;
